import { ExternalLink } from "lucide-react"
import { Button } from "~/components/ui/button"

interface FounderSectionProps {
  onContactClick?: () => void
}

export function FounderSection({ onContactClick }: FounderSectionProps) {
  return (
    <section className="w-full py-12 md:py-24 lg:py-32 bg-gray-50">
      <div className="container px-8 md:px-12 lg:px-16">
        <div className="grid gap-8 lg:grid-cols-2 lg:gap-16 items-center">
          <div className="flex justify-center lg:justify-end order-1 lg:order-1">
            <div className="relative">
              <div className="relative h-[400px] w-[320px] md:h-[480px] md:w-[380px] rounded-2xl overflow-hidden shadow-xl">
                <img
                  src="/images/avatar-an.jpg"
                  alt="John Le - Founder & Silicon Valley Full-Stack Engineer"
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 h-24 w-24 rounded-full bg-primary/10 -z-10" />
              <div className="absolute -top-4 -left-4 h-32 w-32 rounded-full bg-primary/5 -z-10" />
            </div>
          </div>

          <div className="flex flex-col space-y-6 order-2 lg:order-2">
            <div className="space-y-3">
              <div className="inline-block rounded-lg bg-primary/10 px-3 py-1 text-sm text-primary">
                Meet the Founder
              </div>
              <h2 className="text-3xl font-bold tracking-tight leading-tight sm:text-4xl md:text-5xl">John/An Le</h2>
              <p className="text-xl text-gray-600 font-medium leading-relaxed">
                Silicon Valley Full-Stack Software Engineer
              </p>
            </div>

            <div className="space-y-4 text-gray-600 leading-relaxed tracking-normal">
              <p className="leading-7">
                Silicon Valley-based full-stack software engineer with 10+ years of experience taking ideas from concept
                to production deployment. I've helped businesses transform ideas into scalable systems that handle
                millions of users and events.
              </p>
              <p className="leading-7">
                Proficient in building web applications from idea to completion with Ruby on Rails, React, Redis,
                Elasticsearch, Heroku, AWS, and more. I can get agreement on a feature, build it, deliver it, and ensure
                customers use it successfully - all while keeping everyone happy.
              </p>
              <p className="leading-7">
                With proven experience in app version upgrades, performance optimization, infrastructure migrations, and
                scaling systems for millions of users, I bring enterprise-scale expertise with the agility and direct
                communication you need to move fast.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button size="lg" className="bg-primary hover:bg-primary/90 text-white" onClick={onContactClick}>
                Let&apos;s Talk
              </Button>
              <Button
                size="lg"
                variant="outline"
                className="border-gray-300 bg-transparent"
                onClick={() => window.open("https://linkedin.com/in/anhoangle", "_blank")}
              >
                <ExternalLink className="mr-2 h-4 w-4" />
                Connect on LinkedIn
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
